import React, { Component } from 'react';
import Freund from '../components/Freund'; 

class FreundContainer extends Component {
	componentWillMount(){
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}
	componentDidMount(){	
		setTimeout(function(){
			document.getElementById('menu-informationen').classList.add('active');
		},400);
	}
	componentWillUnmount(){
		document.getElementById('menu-informationen').classList.remove('active');
	}
	render() {		   
		   return (
				<Freund staticData={this.props.resolves.staticData} {...this.props.resolves.page} /> 
			)
	   
	}
}
export default FreundContainer;


// WEBPACK FOOTER //
// ./src/containers/FreundContainer.js